import type { AppointmentResultReportCondition } from '@/api/types/ProviderApi'
import { Header } from '@/ui/core/header'
import { VStack } from '@/ui/core/stack'
import { Text } from '@/ui/core/typography'
import { View } from 'react-native'

const ResultCondition = ({
	condition,
}: { condition: AppointmentResultReportCondition }) => (
	<VStack
		className="justify-center max-w-[30rem] gap-6 pb-16 lg:pr-0 lg:pl-0 pr-8"
		key={condition.title}
	>
		<View className="self-start">
			<Header variant="h4" className="bg-palette_5 px-4 py-1">
				{condition.title}
			</Header>
		</View>
		<Text className="text-balance">{condition.description}</Text>
	</VStack>
)

const ResultConditionsList = ({
	conditions = [],
}: { conditions?: AppointmentResultReportCondition[] }) => {
	return (
		<VStack className="items-center justify-center self-center gap-12 px-12">
			<View className="w-full flex items-start ios:self-start android:self-start">
				<Header className="text-3xl">What we found.</Header>
			</View>
			<View>
				{conditions.map((condition) => (
					<ResultCondition key={condition.title} condition={condition} />
				))}
			</View>
		</VStack>
	)
}

export { ResultConditionsList }
